<template>
  <div class="asociacionismo">
    <b-container>
      <b-row class="center">
        <b-col cols="7">
          <div class="button big"></div>
        </b-col>
        <b-col>
          <div class="text">
            <h1>MANUAL ASOCIACIONISMO Y VOLUNTARIADO</h1>
            <p>
              El Manual de Asociacionismo y Voluntariado es una apuesta del Movimiento para
              adaptarse y garantizar el crecimiento y la presencia de Juniors M.D. en la sociedad.
              En él se explican temas necesarios para la vida de los Centros Juniors,
              principalmente en aspectos de gestión y administración.
              Se trata de una respuesta a la necesidad de tener un lugar donde acudir para
              conocer, consultar o informarse sobre nuestra estructura y nuestra identidad.
            </p>
          </div>
        </b-col>
      </b-row>
      <b-row class="footer">
        <b-col cols="auto" class="mr-auto">
          <router-link to="/gestion">
            <div class="button small back"></div>
          </router-link>
        </b-col>
        <b-col cols="auto">
          <b-link href="pdf/manual/asociacionismo.pdf" v-b-tooltip.topright title="Manual de asociacionismo">
            <div class="button small download manual"></div>
          </b-link>
        </b-col>
        <b-col cols="auto">
          <b-link href="pdf/guia/voluntariado.pdf" v-b-tooltip title="Guía de voluntariado">
            <div class="button small download guia"></div>
          </b-link>
        </b-col>
        <b-col cols="auto">
          <b-link href="pdf/guia/conductas-eticas.pdf" v-b-tooltip.topleft title="Guía de conductas éticas">
            <div class="button small download guia"></div>
          </b-link>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>

export default {
  name: 'asociacionismo'
}
</script>

<style lang="scss" scoped>
@import '../styles/common.scss';
</style>
